(function(){
    window.addEventListener('load',function(){
        var a = document.querySelectorAll('.page-faq-section .accordion');
        for (let i = 0; i < a.length; i++) {
            if(i==0){a[i].classList.add('opened')}
            a[i].addEventListener('click',function(e) {
                var t = this;
                if(t.classList.contains('opened')){t.classList.remove('opened')}
                else{t.classList.add('opened')}
            })
        }
    });
})();